import React from "react";
import { AlertTriangleIcon } from "../icons";
import Spinner from "../ui/Spinner";
import { useReportSettings } from "../../hooks/useReportSettings";
import { canMutateTenantData } from "../../config/constants";
import Report20FootprintBaselineCard from "../report20/Report20FootprintBaselineCard";

/**
 * Site Footprint baseline target (Tenant Configuration / Super Admin).
 * Same card as Report 2.0 footprint section.
 */
const FootprintBaselineClientAdminView = ({
  onBack,
  userRole,
  tenantId,
  embedded = false,
  canEdit: canEditProp,
}) => {
  const { footprintBaselineByYear, updateFootprintBaseline, loading, error } =
    useReportSettings(tenantId);
  const canEdit =
    canEditProp != null ? Boolean(canEditProp) : canMutateTenantData(userRole);

  if (loading) {
    return (
      <div
        className={
          embedded
            ? "py-12 flex items-center justify-center"
            : "min-h-screen pt-[155px] bg-brand-background flex items-center justify-center"
        }
      >
        <Spinner />
      </div>
    );
  }

  return (
    <div className={embedded ? "bg-transparent" : "min-h-screen pt-[155px] bg-brand-background"}>
      <div
        className={
          embedded
            ? "overflow-hidden mb-2"
            : "bg-white rounded-md shadow-sm border-0 overflow-hidden mb-6 max-w-full lg:max-w-[85%] mx-5 lg:mx-auto mt-6"
        }
      >
        {!embedded && (
          <div className="border-b border-gray-200 px-6 py-4 flex items-center gap-4">
            {onBack && (
              <button
                type="button"
                onClick={onBack}
                className="text-sm text-gray-600 hover:text-gray-900"
              >
                ← Back
              </button>
            )}
            <h2 className="text-lg font-semibold text-gray-900">
              Site Footprint baseline target
            </h2>
          </div>
        )}
        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md flex items-start gap-2">
            <AlertTriangleIcon className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" />
            <p className="text-sm text-red-700">
              {error?.message || String(error)}
            </p>
          </div>
        )}
        {embedded && (
          <div className="mb-4">
            <h3 className="text-lg font-semibold text-gray-900">
              Site Footprint baseline target
            </h3>
            <p className="mt-1 max-w-3xl text-sm text-gray-500">
              Year-wise site count targets by classification. Managed by Super Admin
              only and shared by every user of this tenant.
            </p>
          </div>
        )}
        <Report20FootprintBaselineCard
          footprintBaselineByYear={footprintBaselineByYear}
          updateFootprintBaseline={updateFootprintBaseline}
          canEdit={canEdit}
          tenantId={tenantId}
        />
      </div>
    </div>
  );
};

export default FootprintBaselineClientAdminView;
